/* eslint-disable @typescript-eslint/no-unused-vars */
export abstract class PlatformStorage implements Storage {
  [name: string]: unknown;
  length = 0;

  abstract key(index: number): string | null;
  abstract getItem<T>(key: string): T | null;
  abstract setItem<T>(key: string, value: T): void;
  abstract removeItem(key: string): void;
  abstract clear(): void;
}
